import React, { useEffect } from 'react';
import { Alert } from 'components/common';
import { useCompany } from 'components/hooks';
import { ROUTES } from 'consts';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { CompanySchema } from 'schemas';
import CompanyFormDumb from './CompanyFormDumb';


const CompanyCreateSmart = () => {
  const history = useHistory();
  const { cleanUpMessage, error, success, postCompany } = useCompany();

  const defaultValues = {
    name: '',
    description: ''
  }

  const handleCloseAlert = () => cleanUpMessage();

  const handleCreate = (data) => {
    const company = new CompanySchema();
    company.setValues(data);
    postCompany({
      body: company.getValues(),
    });
  };

  useEffect(() => {
    if (!!success.post) history.push(ROUTES.COMPANY_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);


  return (
    <>
      <CompanyFormDumb defaultValues={defaultValues} handleOnSubmit={handleCreate} isEdit={false} />
      <Alert severity="error" handleClose={handleCloseAlert} open={error.post} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(CompanyCreateSmart));
